import React from 'react';
import { Popover as AntdPopover } from 'antd';
import { PopoverProps as AntdPopoverProps } from 'antd/lib/popover';

export type PopoverProps = AntdPopoverProps;

export const Popover = (props: PopoverProps) => <AntdPopover {...props} />;

export default Popover;
